import app from "../_app";
const product = document.querySelector('.js-product');

if(product) {
    const productForm = product.querySelector('.js-product-form');
    let currentImage = product.querySelector('.js-product-images').children[0];
    const imageContainer = product.querySelector('.js-product-images');
    const images = product.querySelector('.js-product-images').children;
    const thumbnails = product.querySelector('.js-product-thumbnails').children;
    const dots = product.querySelector('.js-product-dots').children;
    const video = [];
    const videoThumbnail = [];

    const scrollHandler = () => {
        const elements = images;
        let currentIndex = 0;


        if(app.viewport.isEqualOrSmallerThan('md')) {
            const scrollLeft = imageContainer.scrollLeft;

            for(let i = 0; i < elements.length; i++) {
                if((elements[i].offsetLeft + (elements[i].clientWidth * .5)) >= scrollLeft) {
                    currentIndex = i;
                    break;
                }
            }

            if(currentIndex === 1 && video !== null) {
                if((video.offsetLeft + (video.clientWidth * .5)) >= scrollLeft) {
                    currentIndex = images.length;
                }
            }

            [...dots].map((dot, index) => {
                if(index !== currentIndex){
                    dot.classList.remove('product__dot--current');
                }else {
                    dot.classList.add('product__dot--current');
                }
            });

        } else {
            const scrollTop = window.scrollY;
            const top = scrollTop / 2;

            if('scrollBehavior' in document.documentElement.style) {
                productForm.scrollTo({top});
            } else {
                productForm.scrollTop = top;
            }

            for(let i = 0; i < elements.length; i++) {

                if((elements[i].offsetTop + (elements[i].clientHeight * .85)) >= scrollTop) {
                    currentIndex = i;
                    break;
                }
            }

            if(currentIndex === 1 && video !== null) {
                if((video.offsetTop + (video.clientHeight * .85)) >= scrollTop) {
                    currentIndex = images.length;
                }
            }
        }

        [...thumbnails].map((thumbnail, index) => {
            if(index !== currentIndex){
                thumbnail.classList.remove('product__thumbnail--current');
            }else {
                thumbnail.classList.add('product__thumbnail--current');
            }
        });
    };

    const checkForProductVideo = () => {
        let newProductVideo = null;

        if(![null, undefined].includes(props.product.specs) && props.product.specs.length > 0) {
            const productVideoSpec = props.product.specs.find(spec => spec.title === 'productvideo');

            if(productVideoSpec !== undefined && ![null, false, undefined, ''].includes(productVideoSpec.value)) {
                newProductVideo = productVideoSpec.value;
            }
        }

        setProductVideo(newProductVideo);

        if(newProductVideo !== null) {
            setTimeout(() => video.current.childNodes[0].addEventListener('canplay', createVideoThumbnail));
        }
    }

    const createVideoThumbnail = () => {
        const canvas = videoThumbnail.current.getContext('2d');
        const videoElement = video.current.childNodes[0];

        canvas.drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight,
            0, 0, videoThumbnail.current.width, videoThumbnail.current.height);

        video.current.childNodes[0].removeEventListener('canplay', createVideoThumbnail);
    };

    const scrollToImage = index => {
        if(app.viewport.isEqualOrSmallerThan('md')) {

            const left = images[index].offsetLeft;

            if('scrollBehavior' in document.documentElement.style) {
                imageContainer.scrollTo({left, behavior: 'smooth'})
            } else {
                imageContainer.scrollLeft = left;
            }
        } else {
            window.scrollTo({top: images[index].offsetTop + 65, behavior: 'smooth'})
        }
    };

    scrollToImage(0);

    [...thumbnails].map((thumbnail) => {
        thumbnail.addEventListener('click', () => {
            scrollToImage(parseInt(thumbnail.dataset.count));
        });
    });

    [...dots].map((dot) => {
        dot.addEventListener('click', () => {
            scrollToImage(parseInt(dot.dataset.count));
        });
    });

    if(app.viewport.isEqualOrSmallerThan('md')) {
        imageContainer.addEventListener('scroll', scrollHandler);
    } else {
        window.addEventListener('scroll', scrollHandler);
    }
}
